import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
  color: '#20c997',
  failedColor: 'red',
  height: '2px'
})



// WEBPACK FOOTER //
// ./src/plugins/progressBarConfig.js